import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/driver/orders/$id")({
  component: lazyRouteComponent(() => import("./-pages/driver.orders.$id")),
  head: () => ({
    meta: [
      { title: "Driver order · Lecmo" },
      { name: "robots", content: "noindex" },
    ],
  }),
});
